import { LucideProps, LucideIcon } from "lucide-react"
import { createElement } from "react"

export const IconSizes = {
  ExtraExtraSmall: "xxs",
  ExtraSmall: "xs",
  Small: "sm",
  Medium: "md",
  Large: "lg",
  ExtraLarge: "xl",
  ExtraExtraLarge: "xxl",
}
export type IconSize = (typeof IconSizes)[keyof typeof IconSizes]

export interface IconProps extends Omit<LucideProps, "size"> {
  icon: LucideIcon
  size?: IconSize
}

export function Icon({
  icon,
  size = IconSizes.Medium,
  ...otherProps
}: IconProps) {
  return createElement(icon, {
    size: iconSizes[size],
    ...otherProps,
  })
}

const iconSizes: Record<IconSize, number> = {
  [IconSizes.ExtraExtraSmall]: 12,
  [IconSizes.ExtraSmall]: 16,
  [IconSizes.Small]: 20,
  [IconSizes.Medium]: 24,
  [IconSizes.Large]: 32,
  [IconSizes.ExtraLarge]: 48,
  [IconSizes.ExtraExtraLarge]: 64,
}
